export function assertEnumValue<T extends object>(enumObj: T, value: unknown): asserts value is T[keyof T] {
  if (Object.values(enumObj).includes(value as T[keyof T])) {
    return
  }

  throw new Error(`'${value}' is not a value of '${enumObj}'`)
}
